import React from 'react';

import PropTypes from 'prop-types';

import { useBreakpoint } from '~/techstyle-shared/react-components';

import ProductCardSwatchesDesktop from './ProductCardSwatchesDesktop';
import ProductCardSwatchesMobile from './ProductCardSwatchesMobile';

const ProductCardSwatches = ({
  swatches = [],
  activeProductId,
  setActiveProductId = () => {},
  activeProductPdpLink,
}) => {
  const { isMobile } = useBreakpoint();

  return isMobile ? (
    <ProductCardSwatchesMobile
      swatches={swatches}
      activeProductId={activeProductId}
      setActiveProductId={setActiveProductId}
      activeProductPdpLink={activeProductPdpLink}
    />
  ) : (
    <ProductCardSwatchesDesktop
      swatches={swatches}
      activeProductId={activeProductId}
      setActiveProductId={setActiveProductId}
      activeProductPdpLink={activeProductPdpLink}
    />
  );
};

ProductCardSwatches.propTypes = {
  activeProductId: PropTypes.string,
  activeProductPdpLink: PropTypes.string,
  setActiveProductId: PropTypes.func,
  swatches: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

export default ProductCardSwatches;
